// Simple, DSGVO-compliant consent store. No third-party.
// Only stores a minimal boolean flag for statistics/analytics consent.

const KEY = "cookie_consent_v1";

export interface ConsentValue {
  statistics: boolean;
  ts: number;
}

type Listener = (v: ConsentValue | null) => void;
const listeners = new Set<Listener>();

export function getConsent(): ConsentValue | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.statistics !== "boolean") return null;
    return { statistics: !!parsed.statistics, ts: Number(parsed.ts) || Date.now() };
  } catch {
    return null;
  }
}

export function setConsent(statistics: boolean): void {
  const v: ConsentValue = { statistics, ts: Date.now() };
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch {
    // ignore quota errors — no consent persistence == treat as not given
  }
  listeners.forEach((l) => {
    try {
      l(v);
    } catch {
      // never let a listener break others
    }
  });
}

export function clearConsent(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // noop
  }
  listeners.forEach((l) => l(null));
}

export function hasStatisticsConsent(): boolean {
  return !!getConsent()?.statistics;
}

export function onConsentChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
